import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import {
    getSelectedOrderId,
    getSelectedOrderType,
} from 'entities/Order/model/selectors/ordersSelectors';
import { useNavigationBlock } from 'features/NavigationBlockModal/ui/NavigationBlockProvider/NavigationBlockProvider';
import { searchCatalogItemsActions } from 'features/SearchCatalogItems/model/slices/SearchCatalogItemsSlice';
import {
    getPropertyCatalogId,
    getPropertyId,
} from 'features/fetchPropertyById/model/selectors/fetchPropertyByIdSelectors';
import { getRouteOrdersAddItemsCategories } from 'shared/const/router';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

export const useOrderAddItemsCatalogNavigation = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { validateNavBlock } = useNavigationBlock();
    const selectedOrderId = useSelector(getSelectedOrderId);
    const selectedOrderType = useSelector(getSelectedOrderType);
    const selectedPropertyCatalogId = useSelector(getPropertyCatalogId);
    const selectedPropertyId = useSelector(getPropertyId);

    return useCallback(
        (options?: { clearSearch?: boolean }) => {
            validateNavBlock(() => {
                if (options?.clearSearch) {
                    dispatch(catalogItemActions.clearAllItems());
                    dispatch(searchCatalogItemsActions.setActive(false));
                    dispatch(
                        searchCatalogItemsActions.setLocalCatItemSearchValue(
                            '',
                        ),
                    );
                    dispatch(
                        searchCatalogItemsActions.setGlobalCatItemSearchValue(
                            '',
                        ),
                    );
                }

                navigate(getRouteOrdersAddItemsCategories(), {
                    state: {
                        selectedOrderId,
                        selectedPropertyCatalogId,
                        selectedPropertyId,
                        fromOrder: selectedOrderId,
                        orderType: selectedOrderType,
                    },
                });
            }, true);
        },
        [
            dispatch,
            navigate,
            selectedOrderId,
            selectedOrderType,
            selectedPropertyCatalogId,
            selectedPropertyId,
            validateNavBlock,
        ],
    );
};
